import React, {useContext, useState, useEffect} from 'react'
import {Elements} from '@stripe/react-stripe-js'
import {loadStripe} from '@stripe/stripe-js'
import { CheckoutForm } from './StripeCheckout';
import { AppContext } from '../context/AppContext'
import { Loader } from './Loader';
import axios from 'axios';


export function StripeForm({closeModal}) {
  const [stripePromise, setStripePromise] = useState(null)
  const [clientSecret, setClientSecret] = useState("")
  const {appState} = useContext(AppContext)

  useEffect(() => {
    if(appState.stripeKey) {
      setStripePromise(loadStripe(appState.stripeKey))
      var intentData = new FormData()
      intentData.append('productId', appState.course.id)
      intentData.append('_wpnonce', window.ttnonce || window.TTI_REST_NONCE)
      axios.post(appState.envVars.STRIPE_INTENT_API, intentData)
      .then(({data}) => {
        setClientSecret(data.clientSecret)
      })
    }
  }, [appState.stripeKey, appState.course.id, appState.envVars.STRIPE_INTENT_API])

  const appearance = {
    theme: 'stripe'
  }

  const options = {
    clientSecret,
    appearance
  }

  return (
    <>
      {clientSecret ? (
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm secret={clientSecret} />
        </Elements>
      ) : <Loader />}
    </>
  )
}